import axios from 'axios';
import Api from './reconApi';
import HomeInfo from './HomeInfo';
import { readBackfillStatus } from './reconFileBackfill';

export function fetchReconFileBackfill() {
	return Api.get('recon_file_backfills').then(readBackfillStatus);
}

// 202 starts a run. 409 means one is already running and carries the same status.
export function startReconFileBackfill() {
	return axios({
		method: 'post',
		url: `${HomeInfo.host()}recon_file_backfills`,
		validateStatus: status => status === 202 || status === 409,
	}).then(response => readBackfillStatus(response.data));
}
